<template>
  <CCard>
    <CCardHeader>
      <strong>{{ this.$lang.dashboard.header.recent_project_response }}</strong>
      <span style="float: right;">
        <CBadge color="success">{{ count }}</CBadge>
      </span>
    </CCardHeader>
    <CCardBody>
      <CDataTable class="mb-0 table-outline" hover :items="tableItems" :fields="tableFields"
                  @row-clicked="rowClickHandler" head-color="light" no-sorting>
        <td slot="opportunity" slot-scope="{ item }">
          <span :title="item.opportunity">{{ trimfunction(item.opportunity, 15) }}</span>
        </td>
        <td slot="response" slot-scope="{ item }">
          <span :title="item.response">{{ trimfunction(item.response, 15) }}</span>
        </td>
        <td slot="username" slot-scope="{ item }">
          <span :title="item.username">{{ trimfunction(item.username, 15) }}</span>
        </td>
      </CDataTable>
      <CRow v-if="showProfile" style="margin-top: 2px">
        <CCol class="col-12 text-right">
          <button title="View All Profile" v-on:click="viewOpportunityResponses" class="btn btn-light btn-block mb-1">
            View All
          </button>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
import Vue from "vue";
import {ServerTable} from "vue-tables-2";
import store from "../../store/store";
import {Mixin} from "/src/mixins/index.js";
import {dashboardrecentOpportunityResponseList} from "../../store/url";

Vue.use(ServerTable, {}, false);
export default {
  name: "RecentOpportunityResponse",
  mixins: [Mixin],
  data() {
    return {
      self: this,
      count: 0,
      showProfile: false,
      moduleDashboardrecentOpportunityResponseList: dashboardrecentOpportunityResponseList,
      tableItems: [],
      tableFields: [
        {key: "opportunity", label: this.$lang.dashboard.recentOpportunityResponse.opportunity},
        {key: "response", label: this.$lang.dashboard.recentOpportunityResponse.response},
        {key: "username", label: this.$lang.dashboard.recentOpportunityResponse.username},
      ],
    };
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    axios.get(this.listUrlApi(this.moduleDashboardrecentOpportunityResponseList))
        .then((response) => {
          self.tableItems = response.data.data;
          self.count = response.data.count;
          if (response.data.data.length > 0) {
            self.showProfile = true;
          }
        });
  },
  methods: {
    rowClickHandler(item) {
      this.$router.push({path: `projects/view/${item.projectId}`});
    },
    viewOpportunityResponses() {
      this.$router.push({path: `projects`});
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
